import Swiper from 'swiper/bundle'; 

// init Swiper:
const spatSwiper = new Swiper('.spatSwiper', {
    grabCursor: true,
    keyboard: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },	
    slidesPerView: 2.25,
    spaceBetween: 24,
    breakpoints: {
        576: {
            slidesPerView: 2.25,
            spaceBetween: 24,
            slidesPerGroup: 2
        },
        768: {
            slidesPerView: 3.25,
            spaceBetween: 24,
            slidesPerGroup: 3
        },
        992: {
            slidesPerView: 2,
            spaceBetween: 30,
            slidesPerGroup: 2
        },
        1200: {
            slidesPerView: 2.5,
            spaceBetween: 30,
            slidesPerGroup: 2
        },
        1400: {
            slidesPerView: 3,
            spaceBetween: 30,
            slidesPerGroup: 3
        },
        1600: {
            slidesPerView: 4,
            spaceBetween: 30,
            slidesPerGroup: 4
        }
    }
});


const homeTestimonialsSwiper = new Swiper('.homeTestimonialsSwiper', {
    grabCursor: true,
    keyboard: true,
    pagination: {
        el: ".swiper-pagination-testimonials",
        clickable: true,
    },	
    slidesPerView: 1.25,
    spaceBetween: 24,
    breakpoints: {
        576: {
            slidesPerView: 1.25,
            spaceBetween: 24,
            slidesPerGroup: 1
        },
        992: {
            slidesPerView: 2.25,
            spaceBetween: 24,
            slidesPerGroup: 2
        },
    }
});